/**
 * Get URL for web. Don't provide leading slash.
 * @param {string} url URL to go to
 * @returns {string} GrabOn URL
 */
export function urlResolver(url) {
  return goGlobal.WEB_URL + url;
}

export default urlResolver;